<template>
    <div  :id="$style.logos">
        <MirLogo />
        <SbpLogo />
        <VisaLogo />
        <MastercardLogo />
        <!-- <ApplePayLogo /> -->
        <!-- <GooglePayLogo /> -->
        <!-- <PayPalLogo /> -->
    </div>
</template>

<script>
import VisaLogo from "../shapes/VisaLogo";
import MastercardLogo from "../shapes/MastercardLogo";
import MirLogo from "../shapes/MirLogo";
import SbpLogo from "../shapes/SbpLogo";
import ApplePayLogo from "../shapes/ApplePayLogo";
import GooglePayLogo from "../shapes/GooglePayLogo";
// import PayPalLogo from "../shapes/PayPalLogo";

export default {
    name: "PaymentLogos",
    components: {
        VisaLogo,
        SbpLogo,
        MastercardLogo,
        MirLogo,
        ApplePayLogo,
        GooglePayLogo,
        // PayPalLogo
    },
};
</script>

<style module lang="postcss">
#logos {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 0 5px;
}

#logos > svg {
    width: 40px;
    height: 20px;
}

#logos > svg:not(:first-child) {
    margin-left: 5px;
}

@media (max-width: 387px) {
    #logos {
        margin-left: 0;
    }
    
    #logos > svg:not(:first-child) {
        margin-left: 0;
    }
}

#logos > svg:nth-of-type(1) {
    width: 50px;
    height: 16px;
}

#logos > svg:nth-of-type(2) {
    width: 50px;
    height: 26px;
}

#logos > svg:nth-of-type(3) {
    width: 36px;
    height: 20px;
}

#logos > svg:nth-of-type(4) {
    width: 50px;
    height: 20px;
}

#logos > svg:nth-of-type(5) {
    width: 40px;
    height: 16px;
    margin-left: 9px;
}

#logos > svg:nth-of-type(6) {
    width: 16px;
    height: 16px;
    margin-left: 9px;
}
</style>
